import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';

import media from '../../styles/media.style';
import { PAGE_WIDTH } from '../../styles/variables.style';

import Manifesto from './BrandManifesto/BrandManifesto';
import HomeTouts from './HomeTouts/HomeTouts';
import KeyProductLine from './KeyProductLine/KeyProductLine';

const ToutWrapper = styled.section`
  margin: auto;
  width: 100%;

  ${media.tabletP`
    max-width: 600px;
  `};

  ${media.tabletL`
    max-width: ${PAGE_WIDTH}px;
  `};
`;

const ToutSection = styled.div`
  padding-bottom: 480%;
  position: relative;
  width: 100%;

  ${media.tabletL`
    padding-bottom: 120%;
  `};
`;

const HomePage = ({ data, locale }) => (
  <React.Fragment>
    {_.get(data, 'metaData') && (
      <Helmet
        title={_.get(data.metaData, 'title')}
        link={[makeCanonicalTagObj(locale, ''), ...makeHreflangTagArr(data.metaData.region, '')]}
        meta={[
          {
            name: 'description',
            content: _.get(data.metaData, 'description'),
          },
          {
            name: 'keyword',
            content: _.get(data.metaData, 'keyword'),
          },
          // TODO: OGP タグは一旦保留 (2020年01月07日)
          // {
          //   property: 'og:url',
          //   content: _.get(data.metaData, 'url'),
          // },
          // {
          //   property: 'og:type',
          //   content: _.get(data.metaData, 'type'),
          // },
          // {
          //   property: 'og:title',
          //   content: _.get(data.metaData, 'title'),
          // },
          // {
          //   property: 'og:image',
          //   content: _.get(data.metaData, 'image.file.url'),
          // },
          // {
          //   property: 'og:description',
          //   content: _.get(data.metaData, 'description'),
          // },
          // {
          //   property: 'og:site_name',
          //   content: _.get(data.metaData, 'siteName'),
          // },
        ]}
      />
    )}

    <Manifesto locale={locale} manifestos={data.manifestos} />

    <ToutWrapper>
      <ToutSection>
        <HomeTouts topics={data.topics} quote={data.brandQuote} article={data.article} locale={locale} />
      </ToutSection>
    </ToutWrapper>

    <KeyProductLine copy={data.copy} ranges={data.featuredProductRanges} locale={locale} />
  </React.Fragment>
);

HomePage.defaultProps = {
  data: {},
  screenSize: null,
};

HomePage.propTypes = {
  data: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(HomePage);



// WEBPACK FOOTER //
// ./src/pages/HomePage/HomePage.js